import { get } from "lodash";
import { toast } from "react-toastify";

import { checkToastThemeOption } from ".";

const httpSuccessToast = (resp: any, message: string) => {
  const option = checkToastThemeOption();
  const responseType = get(resp, "type");
  if (responseType !== "ERROR") toast.success(message, option);
};

export default httpSuccessToast;
